export default "__VITE_ASSET__isaDojf___"